// extracted by mini-css-extract-plugin
export default {"contenedor":"Politicas_contenedor__EUny9","CLOSE":"Politicas_CLOSE__jf7D4","contenedorTyc":"Politicas_contenedorTyc__5wSuA"};